import { Component } from '@angular/core';
import { VerseReference } from '@models/VerseReference';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ApiService } from '../../api.service';
import { VerseReferenceDialogComponent } from '../verse-reference-dialog/verse-reference-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SynchronizerService } from '../../synchronizer.service';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { CommonTasksService } from 'src/app/common-tasks.service';

@Component({
  selector: 'app-bible-navigator',
  imports: [MatButtonModule, MatIconModule, MatIconModule, MatTooltipModule],
  templateUrl: './bible-navigator.component.html',
  styleUrl: './bible-navigator.component.scss'
})
export class BibleNavigatorComponent {

  constructor(private api: ApiService,
    private synchronizerService: SynchronizerService,
    public dialog: MatDialog,
    public commonTasks: CommonTasksService,
  ) {
  }

  ngOnInit() {
  }

  get reference(): VerseReference | undefined {
    return this.synchronizerService.reference$.value;
  }

  nextVerse() {
    const ref = this.reference?.nextVerse();
    if (ref) {
      this.synchronizerService.updateVerse(ref);
    }
  }

  previousVerse() {
    const ref = this.reference?.previousVerse();
    if (ref) {
      this.synchronizerService.updateVerse(ref);
    }
  }

  private get project(): ProjectConfiguration | undefined {
    return this.synchronizerService.currentProject;
  }

  async seek(direction: "before" | "after", exclusivity: "me" | "anyone") {
    if (this.project && this.synchronizerService.user$.value) {
      try {
        if (this.reference) {
          const ref = await this.api.seekVerse(this.reference, this.synchronizerService.user$.value?.user_id, this.project?.id, this.project.getFrequencyThreshold(this.reference.canon), direction, exclusivity)
          if (ref) {
            this.synchronizerService.updateVerse(ref);
          }
        }
      } catch (error) {
        this.commonTasks.showSnackbarMessage("Error seeking for verse", "OK", 3000);
        console.error("Error seeking verse:", error);
      }
    }
  }

  verseReferenceDialog() {
    const dialogRef = this.dialog.open(VerseReferenceDialogComponent, { data: this.reference })

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.synchronizerService.updateVerse(result);
      }
    });
  }

  get formattedVerseReference(): string {
    if (this.reference) {
      return this.project?.formatVerseReference(this.reference) || "";
    } else {
      return "";
    }
  }


}
